import { motion } from "framer-motion";
import { ReactNode } from "react";
import { useScrollReveal } from "../../../../hooks/useScrollReveal";

interface AnimatedSectionProps {
  children: ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right';
  className?: string;
}

export default function AnimatedSection({
  children,
  delay = 0,
  direction = 'up',
  className = ''
}: AnimatedSectionProps) {
  const { ref, initial, animate } = useScrollReveal({
    delay,
    direction,
    once: true
  });

  return (
    <motion.div
      ref={ref}
      initial={initial}
      animate={animate}
      className={className}
    >
      {children}
    </motion.div>
  );
}
















